import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=a8d1a68e&"
import script from "./Crew.vue?vue&type=script&lang=ts&"
export * from "./Crew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports